const spacing = {
  spacing: (factor: number) => `${0.5 * factor}rem`,
};

export default spacing;
